export enum Icon {
  Alphabet = 1,
  ArrowDownUp,
  ArrowRepeat,
  Award,
  BasketFill,
  Bell,
  BodyText,
  Book,
  BoxHeartFill,
  BoxSeam,
  BoxSeamFill,
  Boxes,
  BuildingGear,
  Calendar3,
  CardList,
  CartX,
  CashCoin,
  Chat,
  CheckCircle,
  CheckCircleFill,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CloudDownloadFill,
  CloudUploadFill,
  ColumnsGap,
  Copy,
  Dash,
  Dash_LG,
  EmojiHeartEyes,
  ExclamationCircleFill,
  Eye,
  Eyedropper,
  Facebook,
  FilePost,
  Folder,
  GearWideConnected,
  GlobeAlt,
  Google,
  GraphUpArrow,
  GridFill,
  HouseFill,
  Instagram,
  List,
  ListTask,
  LockFill,
  NodePlus,
  PauseCircle,
  Pencil,
  People,
  PlayCircle,
  Plus,
  Plus_LG,
  QuestionCircle,
  QuestionCircleFill,
  Recycle,
  SendArrowDown,
  ShieldLock,
  Shop,
  Sliders,
  Speedometer,
  Square,
  SquareHalf,
  Star,
  StarFill,
  StarHalf,
  Tags,
  TextIndentLeft,
  TextIndentRight,
  TextParagraph,
  ThreeDots,
  ThreeDotsVertical,
  Trash,
  Truck,
  UnlockFill,
  X,
  XCircle,
  X_LG,
}
